// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1MJ9Y","content":"LayoutSettings_content__6nZZ4"};